import { useMutation } from '@apollo/client'
import { Box, FormModal, Link, Text } from '@chaine/keychaine'
import React, { useState } from 'react'
import { SubmitHandler } from 'react-hook-form'

import { Toast } from '../../../_shared/components/toast'
import { validations } from '../../../_utils/validations/validations'
import { AppModalProps } from '../components/apps-data'
import { ENABLE_TAILWIND_APP } from '../data/mutations'

/**
 * Saves Turvo app's username, database and password.
 * @param props.app the app
 * @param props.isOpen sets the modal to open or closed
 * @param props.onClose closes the modal
 */
const TailwindModal = React.memo((props: AppModalProps) => {
  const { isOpen, onClose, appType, refetchApps } = props

  const [formError, setFormError] = useState('')

  const { showToast } = Toast()

  const [enableTailwindApp, { loading: enableAppLoading }] = useMutation<{
    enableTailwindAppCredentials: { apiKey: string; appType: string }
  }>(ENABLE_TAILWIND_APP, {
    onCompleted: () => {
      showToast({
        status: 'success',
        title: `Tailwind app is enabled successfully!`
      })
      setFormError('')
      refetchApps()
      closeModal()
    },
    onError: (err) => {
      if (err.message === 'Invalid API Key') {
        setFormError('Please enter correct API Key.')
        showToast({
          status: 'error',
          title: `Please enter correct API Key`
        })
      } else {
        setFormError(`Something went wrong. Please contact support@chaineapp.com. Error: ${err.message}`)
        showToast({
          status: 'error',
          title: `Something went wrong. Please contact support@chaineapp.com. Error: ${err.message}`
        })
      }
    }
  })

  type FieldValues = {
    appApiKey?: string
  }
  const handleSaveDetails: SubmitHandler<FieldValues> = (event) => {
    const { appApiKey } = event
    enableTailwindApp({
      variables: {
        apiKey: appApiKey,
        appType
      }
    })
  }

  const closeModal = () => {
    setFormError('')
    onClose()
  }

  const footer = (
    <Box>
      <Text color="red.600">{formError}</Text>
      <Text>
        {`See `}
        <Link
          color="blue.600"
          href="https://handbook.chaineapp.com/product-guide/carriers/connect-eld/elds/tailwind/"
          target="_blank"
          rel="noopener noreferrer"
        >
          detailed steps here.
        </Link>
      </Text>
    </Box>
  )

  return (
    <>
      <FormModal
        isOpen={isOpen}
        onClose={closeModal}
        title={`Enable ${appType} for Chaine`}
        subtitle={`Enabling this integration requires an API Key.`}
        formSubmitHandler={handleSaveDetails}
        buttonText={'Enable'}
        initialValues={{}}
        validations={validations}
        isLoading={enableAppLoading}
        footer={formError ? footer : <></>}
        modalItems={[
          {
            labelText: 'Tailwind API Key',
            name: 'appApiKey',

            placeHolder: 'Enter the Tailwind API Key',
            type: 'input'
          }
        ]}
      />
    </>
  )
})

TailwindModal.displayName = 'TailwindModal'

export { TailwindModal }
